import { z } from "zod";

import { VoucherI18nInputSchema } from "@/lib/zod/__generated__/validation-schema";

export const voucherI18nInputSchema = VoucherI18nInputSchema.extend({
	name: z.string().min(1),
	description: z.string().min(1),
});

export type VoucherI18nInputSchema = z.infer<typeof voucherI18nInputSchema>;
